import { render } from "./Faq.vue?vue&type=template&id=1813bc2c&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "../assets/css/find.css?vue&type=style&index=0&id=1813bc2c&scoped=true&lang=css&external"
import "./Faq.vue?vue&type=style&index=1&id=1813bc2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1813bc2c"]])

export default __exports__